import { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  ClickAwayListener,
} from "@mui/material";
import { DatePickerV1 } from "components";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const DateRangePicker = ({ fromDate, toDate, onFromChange, onToChange }) => {
  const [open, setOpen] = useState(false);

  const displayValue =
    fromDate && toDate
      ? `${new Date(fromDate).toLocaleDateString()} - ${new Date(
          toDate,
        ).toLocaleDateString()}`
      : fromDate
      ? `${new Date(fromDate).toLocaleDateString()} - End date`
      : toDate
      ? `Start date - ${new Date(toDate).toLocaleDateString()}`
      : "Select date range";

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box sx={{ position: "relative" }}>
        <TextField
          size="small"
          value={displayValue}
          onClick={() => setOpen((prev) => !prev)}
          inputProps={{ readOnly: true }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CalendarMonthIcon
                  fontSize="small"
                  sx={{ cursor: "pointer" }}
                />
              </InputAdornment>
            ),
          }}
          sx={{ width: 200, cursor: "pointer" }}
        />

        {open && (
          <Box
            sx={{
              position: "absolute",
              top: "110%",
              left: 0,
              zIndex: 999,
              background: "#fff",
              boxShadow: 3,
              borderRadius: 1,
              p: 2,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Box>
              <Typography variant="body2" mb={1}>
                From
              </Typography>
              <DatePickerV1 value={fromDate} onChange={onFromChange} />
            </Box>
            <Box>
              <Typography variant="body2" mb={1}>
                To
              </Typography>
              <DatePickerV1
                value={toDate}
                onChange={(date) => {
                  onToChange(date);
                  setOpen(false);
                }}
                minDate={fromDate}
              />
            </Box>
          </Box>
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default DateRangePicker;
